// src/utils.ts
var clearObject = (object) => {
  return Object.keys(object).reduce((acc, curr) => {
    if (typeof object[curr] === "undefined") {
      return acc;
    }
    return { ...acc, [curr]: object[curr] };
  }, {});
};

export {
  clearObject
};
